import { commonTranslationKeys, FormContextValues } from '@dreryk/react-common';
import { ModalConfirmButton } from '@dreryk/react-components';

import { CityInput } from '../../common/CityInput';
import { EmailAddressInput } from '../../common/EmailAddressInput';
import { FlatInput } from '../../common/FlatInput';
import { HouseInput } from '../../common/HouseInput';
import { PhoneNumberInput } from '../../common/PhoneNumberInput';
import { PostcodeInput } from '../../common/PostcodeInput';
import { StreetInput } from '../../common/StreetInput';
import { ServiceProvidingLocationFormBean } from '../common/serviceProvidingLocation';

import { ServiceProvidingLocationNameInput } from './form/fields/ServiceProvidingLocationNameInput';
import { useServiceProvidingLocationUpdateModalDirtyStateUpdate } from './ServiceProvidingLocationUpdateModal.state';
import { StyledServiceProvidingLocationUsingOwnDataUpdateFormPart } from './ServiceProvidingLocationUsingOwnDataUpdateFormPart.styled';

type ServiceProvidingLocationUsingOwnDataUpdateFormPartProps = Pick<
   FormContextValues<ServiceProvidingLocationFormBean>,
   'register' | 'formState'
> & {
   readonly onUpdate: () => Promise<void>;
};

export const ServiceProvidingLocationUsingOwnDataUpdateFormPart = (
   props: ServiceProvidingLocationUsingOwnDataUpdateFormPartProps
): JSX.Element => {
   useServiceProvidingLocationUpdateModalDirtyStateUpdate('usingOwnDataUpdateForm', props.formState.isDirty);

   return (
      <>
         <StyledServiceProvidingLocationUsingOwnDataUpdateFormPart>
            <ServiceProvidingLocationNameInput register={props.register} />
            <CityInput name={'city'} register={props.register} required />
            <PostcodeInput name={'postcode'} register={props.register} required />
            <StreetInput name={'street'} register={props.register} />
            <HouseInput name={'house'} register={props.register} required />
            <FlatInput name={'flat'} register={props.register} />
            <PhoneNumberInput name={'phoneNumber'} register={props.register} required />
            <EmailAddressInput name={'emailAddress'} register={props.register} />
         </StyledServiceProvidingLocationUsingOwnDataUpdateFormPart>
         <ModalConfirmButton label={commonTranslationKeys.save} onClick={props.onUpdate} />
      </>
   );
};
